import { Component, Input, OnInit } from '@angular/core';
import { FlightSegmentSch, OriginDestinationOption } from '../models/OTAAirScheduleResponse';


@Component({
    selector: 'app-card-itinerary-flight-two',
    templateUrl: './card-itinerary-flight-two.component.html',
    styleUrls: ['./card-itinerary-flight-two.component.scss'],
    standalone: false
})
export class CardItineraryFlightTwoComponent implements OnInit{

  @Input() flight: OriginDestinationOption;

  ngOnInit(): void {
    // avoid empty method
  }

}
